// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thread-editor{display:block;position:relative}.thread-editor__droparea{color:#7a7a7a;min-height:150px;margin:15px;border-width:2px;border-color:#a0a0a0}.thread-editor__droparea .droparea-label{font-size:25px}.thread-editor__droparea .glyphicons,.thread-editor__droparea .fas,.thread-editor__droparea .far,.thread-editor__droparea .fal{font-size:65px}", ""]);
// Exports
module.exports = exports;
